import React from "react";

type FullScreenLoaderProps = {
  isLoading: boolean;
};

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center backdrop-blur-md bg-base-100/70">
      <div className="flex flex-col items-center gap-4 p-6 pt-0 rounded-xl">
        {/* Chevron/Text - in front */}
        <h1 className="text-base-content text-[12rem] font-groteskLogo animate-pulse-custom font-light relative z-10">
          ^
        </h1>

        <p className="text-md -mt-40 font-medium text-base-content font-grotesk text-center">
          Logging, learning and <br></br>crunching numbers...
        </p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
